import React, { useEffect, useState } from "react";
import { FaShareAlt } from "react-icons/fa";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Divider } from "primereact/divider";
import { TabView, TabPanel } from "primereact/tabview";
import Noimage from "../../images/3.png";

function SingleProductCars() {
  const productId = sessionStorage.getItem("productId");
  const [product, setProduct] = useState([]);
  const [productImg, setProductImg] = useState([]);
  const [mainImage, setMainImage] = useState("");
  const [visibleDialog, setVisibleDialog] = useState(false);
  const [editableProduct, setEditableProduct] = useState({});

  useEffect(() => {
    if (productId) {
      fetchProductDetails();
      fetchProductImages();
    }
  }, [productId]);

  async function fetchProductDetails() {
    try {
      const res = await fetch(`/allCarsByPID/${productId}`);
      const data = await res.json();
      if (!Array.isArray(data)) throw new Error("Data not in array format");
      setProduct(data);
      setEditableProduct({ ...data[0] });
    } catch (err) {
      console.error("Product fetch error:", err.message);
    }
  }

  async function fetchProductImages() {
    try {
      const res = await fetch(`/allProductsMediaByPID/${productId}`);
      const data = await res.json();
      if (!Array.isArray(data)) throw new Error("Media not in array format");
      setProductImg(data);
      if (data.length > 0) {
        setMainImage(`data:image/png;base64,${data[0].productImages}`);
      }
    } catch (err) {
      console.error("Image fetch error:", err.message);
    }
  }

  const handleThumbnailClick = (img) => {
    setMainImage(`data:image/png;base64,${img.productImages}`);
  };

  const handleShare = (product) => {
    const shareText = `Check out this product: ${product.productName}, Price: ₹${product.price}`;
    const shareUrl = `${window.location.origin}/product/${product.productID}`;
    if (navigator.share) {
      navigator
        .share({ title: product.productName, text: shareText, url: shareUrl })
        .then(() => console.log("Shared"))
        .catch((err) => console.error("Share failed", err));
    } else {
      navigator.clipboard.writeText(shareUrl).then(() => {
        alert("Product link copied to clipboard");
      });
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditableProduct((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    try {
      const res = await fetch(`/updateProductCars/${productId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(editableProduct),
      });
      if (res.ok) {
        alert("Product updated successfully");
        setVisibleDialog(false);
        fetchProductDetails();
      } else throw new Error("Update failed");
    } catch (err) {
      console.error("Update error:", err);
    }
  };

  const sectionHeadingStyle = {
    marginTop: "20px",
    fontWeight: "bold",
    fontSize: "16px",
    color: "#36c2c2",
    borderBottom: "1px solid #ccc",
    paddingBottom: "5px",
  };

  const renderInput = (label, name, value) => (
    <div style={{ display: "flex", marginBottom: "10px" }}>
      <strong style={{ width: "180px" }}>{label}:</strong>
      <InputText
        name={name}
        value={value || ""}
        onChange={handleInputChange}
        className="p-inputtext-sm"
      />
    </div>
  );

  return (
    <>
      {product.map((prdct) => (
        <div
          key={prdct.productID}
          style={{
            display: "flex",
            margin: "50px 50px",
            padding: "20px",
            flexWrap: "wrap",
            gap: "20px",
            backgroundColor: "#fff",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
            borderRadius: "12px",
          }}
        >
          <div style={{ width: "80px" }}>
            {productImg.map((img, idx) => (
              <img
                key={idx}
                src={`data:image/png;base64,${img.productImages}` || Noimage}
                onClick={() => handleThumbnailClick(img)}
                style={{
                  width: "100%",
                  border: mainImage.includes(img.productImages)
                    ? "2px solid #ff6600"
                    : "1px solid #ccc",
                  borderRadius: "10px",
                  marginBottom: "10px",
                  cursor: "pointer",
                  padding: "2px",
                }}
              />
            ))}
          </div>

          <div style={{ flex: "1 1 40%", minWidth: "250px" }}>
            <img
              src={mainImage || Noimage}
              alt="Main"
              style={{
                width: "100%",
                borderRadius: "12px",
                border: "1px solid #ddd",
                maxHeight: "450px",
                objectFit: "cover",
              }}
            />
          </div>

          <div style={{ flex: "1 1 40%", minWidth: "250px" }}>
            <h2 style={{ fontSize: "24px", color: "#333" }}>
              {prdct.productName}
            </h2>
            <p>
              <strong style={{ color: "#555" }}>Price:</strong>
              <span style={{ color: "#e60000", fontSize: "18px" }}>
                {" "}
                ₹{prdct.price}
              </span>
            </p>
            <p>
              <strong>Color:</strong> {prdct.color}
            </p>
            <p>
              <strong>Brand:</strong> {prdct.brand}
            </p>

            <button
              onClick={() => setVisibleDialog(true)}
              style={{
                marginTop: "20px",
                marginLeft: "10px",
                backgroundColor: "#f39c12",
                color: "#fff",
                padding: "10px 20px",
                borderRadius: "8px",
                border: "none",
                cursor: "pointer",
              }}
            >
              Edit Product
            </button>
          </div>
        </div>
      ))}

      <Dialog
        header="Edit Product"
        visible={visibleDialog}
        onHide={() => setVisibleDialog(false)}
        modal
        // style={{ width: "70vw", maxHeight: "80vh" }}
      >
        <TabView>
          <TabPanel header="Product Details">
            <div style={{ padding: "20px" }}>
              <h4 style={sectionHeadingStyle}>General</h4>
              {renderInput(
                "Product Name",
                "productName",
                editableProduct.productName
              )}
              {renderInput("Price", "price", editableProduct.price)}
              {renderInput("Color", "color", editableProduct.color)}
              {renderInput("Brand", "brand", editableProduct.brand)}
              {renderInput(
                "Model Number",
                "modelNumber",
                editableProduct.modelNumber
              )}
              {renderInput("Speed", "speed", editableProduct.speed)}
              {renderInput("Weight", "weight", editableProduct.weight)}

              <h4 style={sectionHeadingStyle}>Power Features</h4>
              {renderInput(
                "Battery Type",
                "batteryType",
                editableProduct.batteryType
              )}
              {renderInput(
                "Battery Included",
                "batteryIncluded",
                editableProduct.batteryIncluded
              )}
              {renderInput(
                "Rechargeable",
                "rechargeable",
                editableProduct.rechargeable
              )}

              <h4 style={sectionHeadingStyle}>Warranty</h4>
              {renderInput("Warranty", "warrenty", editableProduct.warrenty)}
              {renderInput(
                "Covered in Warranty",
                "coveredInWarranty",
                editableProduct.coveredInWarranty
              )}
              {renderInput(
                "Not Covered in Warranty",
                "notCoveredInWarranty",
                editableProduct.notCoveredInWarranty
              )}

              <div style={{ marginTop: "30px", textAlign: "right" }}>
                <button
                  onClick={handleSubmit}
                  style={{
                    backgroundColor: "#28a745",
                    color: "white",
                    padding: "10px 20px",
                    fontSize: "16px",
                    fontWeight: "bold",
                    borderRadius: "8px",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  Submit
                </button>
              </div>
            </div>
          </TabPanel>
          <TabPanel header="Images">
            <div style={{ padding: "20px" }}>
              <p>You can add image editing features here...</p>
            </div>
          </TabPanel>
        </TabView>
      </Dialog>
      <Divider />
    </>
  );
}

export default SingleProductCars;
